/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */
import React, {
    useContext, useState
} from 'react';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { Contact } from 'gw-capability-quoteandbind';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { FormModalPopover ,platformMessages } from 'ml-components-platform-react';
import { MLNotificationBlockUtil, MLAvailableInsuredCandidatesUtil ,MLExceptionErrorHandler} from 'ml-portals-util-react';
import { useModal } from '@jutro/components';
import { MLTagManagerService ,MLModalService } from 'ml-portals-services-react'
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import appConfig from 'app-config';

import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import messages from './WatercraftOperatorsTableActionComponent.messages';
import metadata from './WatercraftOperatorsTableActionComponent.metadata.json5';
import styles from './WatercraftOperatorsTableActionComponent.module.scss';
import WatercraftOperatorPopupComponent from '../WatercraftOperatorPopupComponent/WatercraftOperatorPopupComponent';

import { IntlContext } from '@jutro/legacy/locale';

function WatercraftOperatorsTableActionComponent(props) {
    const modalApi = useModal();
    const {
        submissionVM,
        updateWizardData,
        onAdd,
        onEdit,
        onRemove,
        onCancel,
        validateULPolicy,
        viewModelService,
        syncExposure,
        setBannerMessage,
        isPolicyChange,
        setDisableNextButton
    } = props;

    const {
        clearAlerts,
        clearSuccessAlerts,
        addErrorAlert,
        addSuccessAlert
    } = MLNotificationBlockUtil();

    const {
        filterAvailableUmbrellaInsuredCandidates
    } = MLAvailableInsuredCandidatesUtil();

    const { refreshData } = useDataRefresh();
    const {
        showProgressDialog
    } = MLModalService();
    
    const { EndorsementService } = useDependencies('EndorsementService');
    const { authHeader } = useAuthentication();
    const { handleExceptionErrors , clearExceptionErrors } = MLExceptionErrorHandler();

    const pupModel = _.get(submissionVM, 'lobData.personalUmbrella');
    const { watercraftOperators } = pupModel.coverables;
    const { vehicleOperators } = pupModel.coverables;
    const isGPA = appConfig.portalCode === 'GPA';
    const translator = useTranslator();
    const relationTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('InsuredRelationType_ML');
    const genderTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('GenderType');
    const nameSuffixTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('NameSuffix');


    const [selectedVehicleOperatorFixedID, setSelectedVehicleOperatorFixedID] = useState(undefined);
    const [isInEditMode, updateIsInEditMode] = useState(false);
    let watercraftOperatorToEdit;

    const filterWatercraftOperators = (watercraftOperatorsValue) => {
        return watercraftOperatorsValue.filter(() => true);
    };
    const filteredWatercraftOperators = filterWatercraftOperators(watercraftOperators.value);

    filteredWatercraftOperators.forEach((item) => {
        item.contact.fullName = item.contact.getFullName(nameSuffixTypelist, translator);
    });

    const createNewWatercraftOperator = (fixedID, displayFullName_Ext) => {
        const newWatercraftOperator = {
            fixedID,
            contact: new Contact({ displayFullName_Ext })
        };
        return viewModelService.create(newWatercraftOperator, 'pc', 'metlife.edge.capabilities.common.plugin.dto.PUPWatercraftOperatorDTOML');
    };

    const filterVehicleOperatorsByWatercraftOperators = (vehicleOperatorsValue, watercraftOperatorsValue) => {
        const list = vehicleOperatorsValue.filter((vehOperator) => {
            const foundContacts = watercraftOperatorsValue.filter((watercraftOperator) => watercraftOperator.contact.publicID === vehOperator.contact.publicID);
            return foundContacts.length === 0;
        });

        const aTempVehicleOperatorVM = createNewWatercraftOperator('new', translator(messages.AddNewWatercraftOperator));
        list.push(aTempVehicleOperatorVM.value);
        return list;
    };

    const filteredVehicleOperators = filterVehicleOperatorsByWatercraftOperators(vehicleOperators.value, filteredWatercraftOperators);

    const addWatercraftOperatorAlert = (item) => {
        clearSuccessAlerts();
        if (item.contact.value) {
            addSuccessAlert({...messages.itemHasBeenAdded, args: { displayName: item.contact.value.getDisplayName(' ') }}, 'watercraftOperatorAdded');
        } else {
            addSuccessAlert({...messages.itemHasBeenAdded, args: { displayName: item.contact.getDisplayName(' ') }}, 'watercraftOperatorAdded');
        }
    };

    const undoWatercraftOperatorRemoval = (operator) => {
        watercraftOperators.value.push(operator);
        clearAlerts();
    };


    const resetEditingWatercraftOperator = () => {
        watercraftOperators.value.forEach((wc) => {
            wc.isEditing = false;
        });
    };

    const checkObjectValidity = (watercraftOps) => {
        if (watercraftOps && watercraftOps.children) {
            watercraftOps.children.forEach((watercraftOp) => {
                watercraftOp.contact.isGenderRequired.value = true;
                watercraftOp.value.error = !(watercraftOp.aspects.valid && watercraftOp.aspects.subtreeValid);
            });
        }
    };

    const nameSuffixTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('NameSuffix');

    const onSaveWatercraftOperator = (watercraftOperator, isEdit) => {
        if (watercraftOperator.aspects.valid && watercraftOperator.aspects.subtreeValid) {
            watercraftOperator.contact.updated.value = true;
            watercraftOperator.value.contact.fullName = watercraftOperator.value.contact.getFullName(nameSuffixTypeList, translator);
            checkObjectValidity(watercraftOperators);
            clearAlerts();
            if (!isEdit) {
                watercraftOperators.value.push(watercraftOperator.value);
                addSuccessAlert({...messages.itemHasBeenAdded, args: { displayName: watercraftOperator.contact.value.getDisplayName(' ') }}, 'addedWatercraftOperator');
            }
            updateWizardData(submissionVM);
            refreshData();
            if(validateULPolicy){
                validateULPolicy();
            }
            // call syncExposure if watercraftoperator is added
            if(syncExposure){
                // takes 2 optional parameters
                // first is to determine if its being called for watercraft
                // second is to determine if watercraft operator has been added
                const watercraftPromise = syncExposure();

                showProgressDialog(platformMessages.waiting, watercraftPromise);
            }
            return true;
        }
        return false;
    };

    const setDOBRequiredness = (vehicleOperatorVM) => {
        const { driverType } = vehicleOperatorVM;
        if (driverType === 'household') {
            vehicleOperatorVM.contact.isDateOfBirthRequired = false;
            vehicleOperatorVM.contact.isDateOfBirthForNonDriverRequired = true;
        } else {
            vehicleOperatorVM.contact.isDateOfBirthRequired = true;
            vehicleOperatorVM.contact.isDateOfBirthForNonDriverRequired = false;
        }
    };

    const createWatercraftOperator = () => {
        let vehicleOperatorVM;

        if (!selectedVehicleOperatorFixedID) {
            return null;
        }

        if (selectedVehicleOperatorFixedID !== 'new') {
            const index = vehicleOperators.value.findIndex((vo) => vo.fixedID === parseInt(selectedVehicleOperatorFixedID, 10));
            vehicleOperatorVM = vehicleOperators.children[index];
            clearSuccessAlerts();
        } else {
            const newVehicleOperator = {
                contact: new Contact()
            };
            vehicleOperatorVM = viewModelService.create(newVehicleOperator, 'pc', 'metlife.edge.capabilities.common.plugin.dto.PUPVehicleOperatorDTOML');
        }

        const watercraftOperator = createNewWatercraftOperator();
        watercraftOperator.contact.value = vehicleOperatorVM.contact.value;
        watercraftOperator.relationshipToInsured.value = vehicleOperatorVM.relationshipToInsured.value;
        setDOBRequiredness(vehicleOperatorVM.value);
        return watercraftOperator;
    };

    const addWatercraftOperator = () => {
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Add WatercraftOperator`);
        const watercraftOperatorVM = createWatercraftOperator();
        resetEditingWatercraftOperator();
        watercraftOperatorVM.value.isEditing = true;
        updateIsInEditMode(false);
        updateWizardData(submissionVM);
        if(validateULPolicy){
            validateULPolicy();
        }
        return watercraftOperatorVM;
    };

    const editWatercraftOperator = (index) => {
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Edit WatercraftOperator`);
        const watercraftOperatorVM = watercraftOperators.children[index.index];
        setDOBRequiredness(watercraftOperatorVM.value);
        updateIsInEditMode(true);
        return watercraftOperatorVM;
    };

    const createExposureModal = (exposureVM, isEdit) => {
        const watercraftOperatorModalTitle = isEdit? translator(messages.EditWatercraftOperatorModalTitle) : translator(messages.AddWatercraftOperatorModalTitle);
        updateIsInEditMode(isEdit);
        filterAvailableUmbrellaInsuredCandidates(submissionVM, filteredWatercraftOperators);

        const onRejectAddition = () => {
            const index = watercraftOperators.value.indexOf(exposureVM.value);
            if (index !== -1) {
                if (isInEditMode) {
                    watercraftOperators.value[index] = watercraftOperatorToEdit;
                } else {
                    watercraftOperators.value.splice(index.index, 1);
                }
                updateWizardData(submissionVM);
            }
        };

        const componentProps = {
            title: watercraftOperatorModalTitle,
            actionBtnLabel: commonMessages.mlContinue,
            onSaveAction: onSaveWatercraftOperator,
            CustomComponent: WatercraftOperatorPopupComponent,
            onReject: onRejectAddition,
            viewModelService,
            overrideProps: {
                submissionVM,
                watercraftOperatorVM: exposureVM,
                isEdit
            }
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };


    const onAddWatercraftOperator = () => {
        const watercraftOperatorVM = addWatercraftOperator();
        if (selectedVehicleOperatorFixedID === 'new') {
            if (onAdd) return onAdd(watercraftOperatorVM, onCancel);
            createExposureModal(watercraftOperatorVM, false);
            setDisableNextButton(false);
        } else if (selectedVehicleOperatorFixedID) {
            onSaveWatercraftOperator(watercraftOperatorVM, false);
            setDisableNextButton(false);
        } else  {
            addWatercraftOperatorAlert(watercraftOperatorVM.value);
            if(onCancel) onCancel();
        }
    };

    const onEditWatercraftOperator = (index) => {
        const watercraftOperatorVM = editWatercraftOperator(index);
        if (onEdit) return onEdit(watercraftOperatorVM, onCancel);
        createExposureModal(watercraftOperatorVM, true);
        setDisableNextButton(false);
    };

    const hasWatercrafts = () => {
        return pupModel.coverables.watercrafts.children.length > 0;
    };

    const isMissingOperators = () => {
        if (!hasWatercrafts()) {
            return false;
        }
        return (hasWatercrafts()
        && (!watercraftOperators.value || watercraftOperators.children.length === 0));
    };

    const onRemoveWatercraftOperator = (index) => {
        clearExceptionErrors();

        if(setBannerMessage){
            setBannerMessage(null);
        }

        const payloadVM = viewModelService.clone(submissionVM);
        const tempWaterCraftVM = viewModelService.clone(watercraftOperators);
        
        tempWaterCraftVM.value.splice(index.index, 1);
        _.set(payloadVM, 'value.lobData.personalUmbrella.coverables.watercraftOperators', tempWaterCraftVM.value)
        
        let payLoad =  payloadVM.value
        let serviceCall = LoadSaveService.updateDraftSubmission

        if(isPolicyChange){
            serviceCall = EndorsementService.saveEndorsement
            payLoad =  [payloadVM.value]
        }

        const promise = serviceCall(payLoad, authHeader);

        showProgressDialog(platformMessages.loading,promise);

        promise.then((updateSubmission) => {
            MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Remove Excluded WatercraftOperator`);
            
            const watercraftOperatorToRemove = watercraftOperators.value[index.index];
            
            if (onRemove) {return onRemove(watercraftOperatorToRemove, onCancel);}
            setDisableNextButton(false);
            const displayName = watercraftOperatorToRemove.contact.getDisplayName(' ');
            const alertName = `removed${displayName}`;
            
            clearSuccessAlerts();
            addSuccessAlert({ ...messages.itemHasBeenRemoved, args: { displayName: displayName } }, alertName, () => undoWatercraftOperatorRemoval(watercraftOperatorToRemove))
            watercraftOperators.value.splice(index.index, 1);
            checkObjectValidity(watercraftOperators);

            if (isGPA && isMissingOperators()) {
                clearSuccessAlerts();
                addErrorAlert(messages.MissingWatercraftOperators, 'missingWatercraftOperators');
            }

            const updatedSubmissionVM = viewModelService.create(
                updateSubmission,
                'pc',
                'edge.capabilities.quote.submission.dto.QuoteDataDTO',
            );

            updateWizardData(updatedSubmissionVM);

            if (validateULPolicy) {
                validateULPolicy();
            }
        })
        .catch((e) => {
            if (setBannerMessage) {
                const errorMessages = handleExceptionErrors(e, false);

                setBannerMessage(errorMessages[0].trim());
            }
            else {
                handleExceptionErrors(e)
            }
            
        })


    };

    const intl = useContext(IntlContext);
    const generateWatercraftOperatorOverrides = () => {
        if (watercraftOperators.value) {
            const getFormattedDateString = (gwDateVal) => {
                const date = LocalDateUtil.toMidnightDate(gwDateVal);
                return intl.formatDate(date, { year: 'numeric', month: '2-digit', day: '2-digit' });
            };
            const getTypeKeyDescription = (typeKeyName) => {
                return translator({
                    id: typeKeyName,
                    defaultMessage: typeKeyName
                });
            };

            const overrides = watercraftOperators.value.map((watercraftOperator, index) => {
                return {
                    [`nameCell${index}`]: {
                        content: <strong>{watercraftOperator.contact.fullName}</strong>
                    },
                    [`nameCellStatus${index}`]: {
                        visible: _.isString(watercraftOperator.error)
                    },
                    [`dobCell${index}`]: {
                        content: getFormattedDateString(watercraftOperator.contact.dateOfBirth)
                    },
                    [`genderCell${index}`]: {
                        content: (watercraftOperator.contact.gender) ? getTypeKeyDescription(genderTypeList.getCode(watercraftOperator.contact.gender).name) : ''
                    },
                    [`relationshipCell${index}`]: {
                        content: (watercraftOperator.relationshipToInsured) ? getTypeKeyDescription(relationTypeList.getCode(watercraftOperator.relationshipToInsured).name) : ''
                    },
                    [`yearsOperatingWatercraftCell${index}`]: {
                    content: watercraftOperator.yearsOfExperience
                        ? String(watercraftOperator.yearsOfExperience)
                        : ''
                    },
                    [`editActionCell${index}`]: {
                        content: 'Edit',
                        'aria-labelledby': `nameCellContent${index} dobCellContent${index} genderCellContent${index} relationshipCellContent${index} yearsOperatingWatercraftCellContent${index}`
                    },
                    [`removeActionCell${index}`]: {
                        content: 'Remove',
                        'aria-labelledby': `nameCellContent${index} dobCellContent${index} genderCellContent${index} relationshipCellContent${index} yearsOperatingWatercraftCellContent${index}`
                    },
                };
            });
            return Object.assign({}, ...overrides);
        }
        return {};
    };

    const formatAvailableValues = (vehicleOps) => {
        if (!vehicleOps) return [];
        return vehicleOps.map((vehicleOp) => ({
            code: vehicleOp.fixedID,
            name: translator({
                id: vehicleOp.contact.displayName,
                defaultMessage: vehicleOp.contact.displayFullName_Ext
            })
        }));
    };

    const overrideProps = {
        watercraftOperatorHeader: {
            className: classNames('vertical-spacing-20', isGPA ? styles['section-header'] : styles['amp-section-header']),
            content: translator(messages.WatercraftOperatorHeader)
        },
        WatercraftOperatorTable: {
            className: watercraftOperators.length > 0 ? 'stack-table' : ''
        },
        watercraftOperatorParagraph: {
            visible: filteredWatercraftOperators.length <= 0,
            content: translator(messages.WatercraftOperatorParagraph)
        },
        headerRow: {
            visible: filteredWatercraftOperators.length > 0,
        },
        watercraftOperatorsIterable: {
            visible: filteredWatercraftOperators.length > 0,
            data: watercraftOperators.value
        },
        watercraftOperatorDropdown: {
            availableValues: formatAvailableValues(filteredVehicleOperators),
            value: selectedVehicleOperatorFixedID,
            onValueChange: (value) => { setSelectedVehicleOperatorFixedID(value); }
        },
        mlTableActionsDefaultButton: {
            className: 'display-inline-block margin-top-20',
            type: isGPA ? 'outlined' : 'filled',
            content: translator(messages.AddWatercraftOperator),
            disabled: selectedVehicleOperatorFixedID === undefined,
            onClick: onAddWatercraftOperator
        },
        ...generateWatercraftOperatorOverrides()
    };

    const resolvers = {
        resolveCallbackMap: {
            onEditWatercraftOperator,
            onAddWatercraftOperator,
            onRemoveWatercraftOperator,
        },
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={submissionVM}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            onModelChange={updateWizardData}
        />
    );
}

WatercraftOperatorsTableActionComponent.propTypes = {
    submissionVM: PropTypes.shape({}).isRequired,
    updateWizardData: PropTypes.func.isRequired,
};

export default WatercraftOperatorsTableActionComponent;
